define('Components/AboutCornerWidget/js/views/AboutCornerInsightsWidgetInstanceView',[
    'jquery',
    'WidgetInstanceView',
    'app',
    'template!Components/AboutCornerWidget/templates/insights',
    'InternalLinkView',
    'router'
],
function($, WidgetInstanceView, app, historyTemplate, InternalLinkView, router){
    var currentSlide = 0
    return WidgetInstanceView.extend({
        name: 'AboutCornerInsightsWidgetInstanceView',
        events: {
            'click .about-corner-insights__button': 'clickButton',
            'click .about-corner-insights__arrow': 'clickArrow'
        },
        afterRender:function(){
            var view = this;
            if (app.isMobile()) {
                var wrapper = this.$('.about-corner-insights__wrapper')
                wrapper.on('touchstart',function(event){
                    view.touchstartX = event.originalEvent.changedTouches[0].screenX;
                });
                wrapper.on('touchend',function(event){
                    view.touchendX = event.originalEvent.changedTouches[0].screenX;
                    view.handleGesture();
                });
            }
        },
        handleGesture:function(){
            var view = this,
                tolerance = 25;

            if (view.touchendX + tolerance < view.touchstartX) {
                this.goNext();
                
            }
            if (view.touchendX - tolerance > view.touchstartX) {
                this.goPrevious();
                
            }
        },

        getTemplate: function () {
            return historyTemplate;
        },

        initSlider: function() {

        },

        goToSlide: function() {
            if (!app.isMobile()) { return }

            var wrapper = this.$('.about-corner-insights__wrapper')
            wrapper.css('transform', 'translate(-'+ currentSlide * 80 +'vw)')
        },

        clickButton: function(e) {
            e.preventDefault()
            var currentTarget = $(e.currentTarget),
                index = currentTarget.data('index');

            currentSlide = index
            this.goToSlide(index)
        },

        goPrevious:function() {
            if (currentSlide - 1 < 0) { return }
            currentSlide = currentSlide - 1
            
            this.goToSlide(currentSlide)
        },
        goNext:function() {
            if (currentSlide + 1 >= 3) { return }
            currentSlide = currentSlide + 1

            this.goToSlide(currentSlide)
        },

        clickArrow: function(e) {
            e.preventDefault()
            var currentTarget = $(e.currentTarget),
                direction = currentTarget.data('direction');

            if (direction === 0) {
                this.goPrevious()
            } else {
                this.goNext()
            }
        }
    })
});
